import { render, staticRenderFns } from "./newExamTopicDialog.vue?vue&type=template&id=f238cd8c"
import script from "./newExamTopicDialog.vue?vue&type=script&lang=js"
export * from "./newExamTopicDialog.vue?vue&type=script&lang=js"
import style0 from "./newExamTopicDialog.vue?vue&type=style&index=0&id=f238cd8c&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports